angular.module('salesPath2')
  .controller('propertySumRenewalInsuredModalCtrl', ['$scope',
    function($scope) {

     $scope.init();

    }
  ]);
